import 'core-js/stable';
import 'custom-event-polyfill';

import '../src/js/utils/purify';

import '../src/css/itp/master.scss';

// Import global plugins
import '../src/plugins';

// Import utils
import '../src/js/utils';

// Import necessary code for foot_analytics
import '../src/js/utils/foot_analytics';

// Import all files which need to be executed when the page loads
import '../src/js/itp/addressbook';
import '../src/js/itp/cta';
import '../src/js/itp/document-register';
import '../src/js/itp/general';
import '../src/js/itp/rfq';
import '../src/js/itp/tender';
import '../src/js/itp/unsub';
import '../src/js/itp/quote-submission';
import '../src/js/itp/itp-navbar';
